<template>
  <div>
    <div class="bk-doctor">
      <div class="content-title">预约信息</div>
      <van-row>
        <van-cell title="预约医生" value="内容">{{bookInfo.docname}}</van-cell>
        <van-cell title="职称" value="内容">{{bookInfo.doctech}}</van-cell>
        <van-cell title="就诊日期" value="内容">{{simpleDate(bookInfo.bookdate)}}</van-cell>
        <van-cell title="预约时间段" value="内容">{{period[bookInfo.bookperiod]}}</van-cell>
        <van-cell title="挂号金额" value="内容">{{bookInfo.fee}}元</van-cell>
      </van-row>
    </div>
    <div class="bk-customer">
      <div class="content-title">
        <van-row>
          <van-col span="20">
            <van-field readonly clickable name="picker" :value="curAddressInfo.cusname" label="就诊人" placeholder="请确认"
                     @click="show= true"/>
            <van-popup v-model="show" position="bottom">
              <van-picker title="就诊人" show-toolbar :columns="addresslist" @confirm="afterSelAddr"
                          @cancel="show= false" />
            </van-popup>
          </van-col>
          <van-col span="4">
            <van-button class="bt-newaddr" type="primary" block round @click="NewAddr()">新增</van-button>
          </van-col>
        </van-row>
      </div>
      <van-cell title="姓名" value="内容">{{curAddressInfo.NAME}}</van-cell>
      <van-cell title="性别" value="内容">{{ sex[curAddressInfo.SEX] }}</van-cell>
      <van-cell title="年龄" value="内容">{{curAddressInfo.AGE}}</van-cell>
      <van-cell title="手机号码" value="内容">{{curAddressInfo.MOBILE}}</van-cell>
    </div>

    <div class="bk-function'" style="position:fixed; bottom: 20px;width:100%">
      <van-button type="primary" block round @click="postBook" :disabled="hasPay">提交预约</van-button>
    </div>
  </div>
</template>

<script>

import {simpleDate} from "@/common/js/utils";
import {customerBussiness, WeChatPayCall } from "@/service/MpServer";
import {Toast,Dialog} from "vant";

export default {
  components: { },

  name: 'CusDocBook',
  data() {
    return {
      isWinXinClient: false,
      sex: ['男', '女'],
      period: {'AM':'上午', 'PM':'下午'},
      bookInfo: {},
      show: false,
      addresslist:[],
      cascaderValue: '',
      curAddressInfo:{},

      paydata:{},
      bookSucdInfo:{},
      hasPay: false
    }
  },

  watch:{
    $route:{
      handler: function(route){
        this.bookInfo= JSON.parse(this.$route.query.bookInfo);
          this.getAddressList();
      },
      immediate:true
    }
  },

  methods: {
    simpleDate,

    getAddressList() {
      let _this = this;
      let param = {};
      customerBussiness("CUSTOMER_WECHAT", "getWAddressList", param, function (data) {
        let list = JSON.parse(data).Table;
        for (let ad of list) {
          _this.addresslist.push({text: ad.NAME, value: ad});
        }
        (list.length > 0) ? _this.curAddressInfo = list[0] : {};
      });
    },

    afterSelAddr(value, index) {
      this.curAddressInfo = value.value;
      this.show = false;
    },

    NewAddr() {
      this.$router.push({path: '/CusAddress', query: {name: ""}});
    },

    postBook() {
      if (!this.curAddressInfo.NAME) {
        this.$toast("请先选择就诊人!");
        return;
      }
      if (!this.curAddressInfo.ID){
        this.$toast("就诊人身份证号不能为空!");
        setTimeout(()=>{
          this.$router.push({path: '/CusAddress', query: {address: JSON.stringify(this.curAddressInfo)}});
        }, 1000);

        return;
      }


      let _this = this;
      let param = {
        doctor: this.bookInfo.docid, date: simpleDate(this.bookInfo.bookdate),
        period: this.bookInfo.bookperiod, cusaddr: this.curAddressInfo.CUSTOMER_ADDRESS_ID,
        schid: this.bookInfo.bookschId
      };
      param = {srcData: JSON.stringify(param)};
      customerBussiness("CLINIC_BOOK", "PostWCusBook20230624", param, function (data) {
        let jsonData = JSON.parse(data);
        _this.bookSucdInfo= jsonData;

        if ((jsonData.WECHAT_BOOK_PAY) && (jsonData.WECHAT_BOOK_PAY== "True")){
          _this.callPay(jsonData.keyid);
        }
        else {
          _this.hasPay= true;
          if (jsonData.seq != "0") {
            Dialog({ message: "您已预约了[" + _this.bookInfo.docname + "]医生门诊，" + " 就诊序号：[" + jsonData.seq + "]"});
          } else {
            Dialog({message: "您已经预约了[" + _this.bookInfo.docname + "]医生门诊，请看诊当天至挂号处缴费取号，就诊顺序按现场缴费顺序为准!"});
          }
        }

        close();
      });
    },

    callPay(key) {
      let _this= this;
      WeChatPayCall("CLINIC_ORDER", {key: key}, function (data) {  //发起支付申请
        _this.paydata = JSON.parse(data);
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
          }
        } else {
          _this.onBridgeReady();
        }
      });
    },

    onBridgeReady() {
      let _this= this;
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
          "appId": _this.paydata.appid,
          "timeStamp": _this.paydata.timeStamp,
          "nonceStr": _this.paydata.nonceStr,
          "package": "prepay_id=" + _this.paydata.prepay_id,
          "signType": "MD5",
          "paySign": _this.paydata.paySign
        },
        function (res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            _this.hasPay= true;
            Dialog({message:"支付成功，您已预约了[" + _this.bookInfo.docname + "]医生门诊，" + " 就诊序号：[" + _this.bookSucdInfo.seq + "]"});
          }
        }
      );
    },

  }
}

</script>

<style lang="less" scoped >
@import '../../common/style/mixin';

body {
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif !important;
  font-size: 12px !important;
}
.content-title{
  font-size: 16px;
  font-weight: 600;
  background: #FFFFFF;
  height: 30px;
  line-height: 25px;
  padding: 10px 0px 2px 10px;
}

.bt-newaddr{
  top:10px;
  height: 25px;
  font-size: 10px;
  line-height: 25px;
  width: 50px;
}

</style>
